export default function Hero() {
  const scrollToForm = () => {
    const el = document.getElementById('lead-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToOpportunity = () => {
    const el = document.getElementById('opportunity');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-end pb-24 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/f5c2fbd2-009e-4007-925f-0a8e75ed6c39/83c49502-496d-4f6d-9a4d-9f94e19ff33a_Padel-villa.png?v=1595385840332accc2ab973782478d9f"
          alt="Luxury villa with private padel court"
          className="w-full h-full object-cover object-top"
          style={{ filter: 'blur(3px)', transform: 'scale(1.05)' }}
        />
      </div>

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          {/* Pill label */}
          <div className="inline-flex items-center gap-2 border border-white/50 text-white/90 text-xs font-inter font-medium tracking-[0.15em] uppercase px-4 py-2 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4845C] inline-block" />
            Exclusive Launch Partner Programme
          </div>

          {/* Headline */}
          <h1 className="font-cormorant text-6xl lg:text-7xl font-light leading-[1.05] text-white mb-6">
            Where Luxury Travel<br />
            <em className="font-light italic">Meet the Court</em>
          </h1>

          {/* Subheadline */}
          <p className="font-inter font-light text-lg text-white/80 leading-relaxed mb-10 max-w-xl">
            The Mediterranean&apos;s first curated platform for high-end villas with private padel courts.
            Join our founding partner programme and connect your property with the world&apos;s most passionate padel travellers.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={scrollToForm}
              className="whitespace-nowrap bg-[#D4845C] text-white font-inter font-medium text-sm px-8 py-4 rounded-full hover:bg-[#c4734b] transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              Register Your Villa
              <i className="ri-arrow-right-line" />
            </button>
            <button
              onClick={scrollToOpportunity}
              className="whitespace-nowrap text-white font-inter font-medium text-sm flex items-center gap-2 cursor-pointer hover:text-[#D4845C] transition-colors duration-200"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-white/50 hover:border-[#D4845C] transition-colors">
                <i className="ri-play-fill text-xs" />
              </span>
              Discover the Platform
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToOpportunity}
        className="absolute bottom-8 right-8 w-10 h-10 flex items-center justify-center rounded-full border border-white/40 text-white/60 hover:text-white hover:border-white/80 transition-all cursor-pointer animate-bounce"
      >
        <i className="ri-arrow-down-line" />
      </button>
    </section>
  );
}
